export default __webpack_public_path__ + "static/media/lower-silhouette.cbf54bbc.svg";